var login = {
    welcome: "BIENVENIDO",
    text1: "Iniciar sesión - Todos los campos son obligatorios",
    text2: "Ingresa tu Email y Contraseña",
    updateNoticeTitle: "Renovamos la plataforma",
    updateNoticeText: "Actualizamos la plataforma con algunas mejoras. Para seguir disfrutándola, solo necesitas crear una nueva contraseña antes de iniciar sesión; te tomará menos de un minuto.",
    updateNoticeAction: "Haz clic en \"¿Olvidaste tu Contraseña?\", escribe tu correo y sigue las instrucciones que recibirás para crear una nueva contraseña.",
    email: "Email:",
    password: "Contraseña:",
    keep: "Mantenme conectado",
    loginbtn: "Iniciar sesión",
    link1: "Registro",
    link2: "¿Olvidaste tu Contraseña?"
}
module.exports = login
